// GeoJSON Polygon/MultiPolygon Subset — WGS84 (lon, lat) Reihenfolge
export interface GeoJSONPolygon {
  type: 'Polygon';
  coordinates: number[][][];
}

export interface GeoJSONMultiPolygon {
  type: 'MultiPolygon';
  coordinates: number[][][][];
}

export type BPlanGeometry = GeoJSONPolygon | GeoJSONMultiPolygon;

export const GEBIETSARTEN = [
  'WR',
  'WA',
  'WS',
  'WB',
  'MD',
  'MI',
  'MK',
  'MU',
  'GE',
  'GI',
  'SO',
  'sonstiges',
  'unklar',
] as const;

export type Gebietsart = (typeof GEBIETSARTEN)[number];

export const GEBIETSART_LABELS: Record<Gebietsart, string> = {
  WR: 'Reines Wohngebiet (WR)',
  WA: 'Allgemeines Wohngebiet (WA)',
  WS: 'Kleinsiedlungsgebiet (WS)',
  WB: 'Besonderes Wohngebiet (WB)',
  MD: 'Dorfgebiet (MD)',
  MI: 'Mischgebiet (MI)',
  MK: 'Kerngebiet (MK)',
  MU: 'Urbanes Gebiet (MU)',
  GE: 'Gewerbegebiet (GE)',
  GI: 'Industriegebiet (GI)',
  SO: 'Sondergebiet (SO)',
  sonstiges: 'Sonstiges',
  unklar: 'Unklar (noch zu prüfen)',
};

export interface BebauungsplanListItem {
  id: number;
  city_id: number;
  name: string;
  plan_nr: string | null;
  gebietsart: Gebietsart;
  rechtskraft_datum: string | null;
  source: string;
  created_at: string | null;
  deleted_at: string | null;
  geometry_geojson?: BPlanGeometry | null;
}

export interface Bebauungsplan {
  id: number;
  city_id: number;
  name: string;
  plan_nr: string | null;
  gebietsart: Gebietsart;
  rechtskraft_datum: string | null;
  notizen: string | null;
  geometry_geojson: BPlanGeometry | null;
  bbox_min_lat: number | null;
  bbox_max_lat: number | null;
  bbox_min_lon: number | null;
  bbox_max_lon: number | null;
  source: string;
  external_id: string | null;
  created_at: string | null;
  updated_at: string | null;
  created_by_user_id: number | null;
  updated_by_user_id: number | null;
  deleted_at: string | null;
  deleted_by_user_id: number | null;
  deleted_reason: string | null;
}

export interface BebauungsplanCreate {
  name?: string | null;
  plan_nr?: string | null;
  gebietsart?: Gebietsart;
  rechtskraft_datum?: string | null;
  notizen?: string | null;
  geometry_geojson?: BPlanGeometry | null;
}

export interface BebauungsplanUpdate {
  name?: string;
  plan_nr?: string | null;
  gebietsart?: Gebietsart;
  rechtskraft_datum?: string | null;
  notizen?: string | null;
  /** `null` löscht die Geometrie explizit; weglassen lässt sie unverändert. */
  geometry_geojson?: BPlanGeometry | null;
}

export interface ListingBebauungsplanMatch {
  id: number;
  name: string;
  plan_nr: string | null;
  gebietsart: Gebietsart;
  rechtskraft_datum: string | null;
}

export interface ListingBebauungsplanResponse {
  has_coordinates: boolean;
  matches: ListingBebauungsplanMatch[];
  is_reines_wohngebiet: boolean;
}
